import styled from 'styled-components';

// Card Root
const StyledCardPaper = styled.div`
  height: ${(props) => props.height ? `${props.height}px` : `100%`};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth2};
  overflow-y: ${(props) => props.scroll ? 'auto' : 'hidden'};
  scrollbar-width: thin !important;
`;

// Card Header
const StyledCardHeader = styled.div`
  height: auto;
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: ${(props) => props.divider ? `1px solid ${props.theme.colors.greyLight}` : 'none'};
`;

// Card Header Avatar
const StyledCardHeaderAvatar = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 8px;
`;

// Card Header Title
const StyledCardHeaderTitle = styled.div`
  flex: 1;
  padding: 8px;
`;

// Card Header Action
const StyledCardHeaderAction = styled.div`
  display: flex;
  justify-content: flex-end;

  .MuiSvgIcon-root {
    font-size: 20px;
  }
`;

// Card Content
const StyledCardContent = styled.div`
  height: ${(props) => props.scroll ? 'calc(100% - 74px)' : ''};
  padding: 8px;
  overflow-y: auto;
  scrollbar-width: thin !important;
`;

export const Card = {
  Paper: StyledCardPaper,
  Header: StyledCardHeader,
  HeaderAvatar: StyledCardHeaderAvatar,
  HeaderTitle: StyledCardHeaderTitle,
  HeaderAction: StyledCardHeaderAction,
  Content: StyledCardContent
};